var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 62,
    viewBox: "0 0 69 62",
    width: 69,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 45.8335,
    fill: "#eb4f92",
    r: 15.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 21.8335,
    fill: "#eb4f92",
    opacity: 0.5,
    r: 21.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.0011 6.33396c-8.5868 0-16.19258 4.15154-20.9247 10.55754l8.0302 13.9088h.0023c.3731-3.1304 1.8701-6.0175 4.214-8.1264 2.3438-2.1071 5.3736-3.2935 8.5239-3.3337.0513-.0045.1027-.009.1541-.0067h22.5201c-4.4911-7.7736-12.8854-13-22.5201-13zm-22.51999 12.99764c-2.20979 3.8253-3.48111 8.2627-3.48111 13.0017 0 13.3907 10.0883 24.3949 23.092 25.8386l8.0194-13.8865v-.0023c-1.6154.6927-3.3538 1.0502-5.11 1.0502-4.5715-.0045-8.8013-2.4109-11.1447-6.3344-.0425-.0514-.0805-.1073-.114-.1654zm22.51999 2.6031v-.0022c-2.7572 0-5.4026 1.0971-7.353 3.0477-1.9506 1.9506-3.0476 4.5962-3.0476 7.3531 0 2.757 1.0971 5.4028 3.0476 7.3531 1.9507 1.9507 4.5961 3.0477 7.353 3.0477s5.4027-1.0971 7.353-3.0477c1.9507-1.9506 3.0477-4.5961 3.0477-7.3531 0-2.7569-1.0971-5.4028-3.0477-7.3531-1.9506-1.9507-4.5961-3.0477-7.353-3.0477zm7.778 0v-.0022c3.2823 2.4511 5.2173 6.3052 5.2217 10.4013-.0044 2.2054-.5697 4.3727-1.6445 6.2989-.0268.0693-.0581.1363-.096.2011l-11.2592 19.4997c14.3737 0 25.9989-11.6254 25.9989-25.9994 0-3.7001-.7731-7.2147-2.1628-10.4013h-16.0582z",
    fill: "#f5dfe8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIcon);
export default __webpack_public_path__ + "static/media/chrome_icon.ff95fc46b20a4949d0e76a2315ef878a.svg";
export { ForwardRef as ReactComponent };